import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setActiveStep } from "../new-booking-form.slice";
import { BOOKING_AS } from "../../../config/constant";

function SkipApplicant() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { activeStep, applicantData } = useSelector(
    (state) => state?.newBookingForm
  );
  const isIndividualFlow = applicantData?.bookingAs === BOOKING_AS.INDIVIDUAL;

  const handleSkipApplicant = () => {
    let firstNullApplicant = null;

    for (let i = 1; i <= applicantData.noOfApplicants; i++) {
      const key = `applicant${i}`;
      if (applicantData[key] == null) {
        firstNullApplicant = i;
        break;
      }
    }

    if (firstNullApplicant) {
      dispatch(
        setActiveStep(
          isIndividualFlow ? firstNullApplicant - 1 : firstNullApplicant + 1
        )
      );
    }
  };

  if (
    !applicantData?.groupId ||
    !applicantData?.applicant1 ||
    (isIndividualFlow ? activeStep !== 0 : activeStep !== 2) ||
    Array.from(
      { length: applicantData?.noOfApplicants },
      (_, i) => applicantData?.[`applicant${i + 1}`]
    ).every((a) => a != null)
  ) {
    return;
  }

  return (
    <>
      <Box
        component="ul"
        sx={{
          border: "1px solid #DADADA",
          borderRadius: "8px",
          padding: "16px",
          paddingInlineStart: "40px",
        }}
      >
        <Typography
          component="li"
          variant="body2"
          sx={{
            listStyleType: "disc",
            color: "#1A407D",
            fontWeight: 600,
            fontSize: "14px",
            textAlign: "justify",
            my: 1,
          }}
        >
          {t("skipApplicant.text1")}{" "}
          <Typography
            component="span"
            sx={{ color: "#1C252E", fontWeight: "600", fontSize: "14px" }}
          >
            {t("skipApplicant.text2")}
          </Typography>
          .
        </Typography>
        <Typography
          component="li"
          variant="body2"
          sx={{
            listStyleType: "disc",
            color: "#1A407D",
            fontWeight: 600,
            fontSize: "14px",
            textAlign: "justify",
            my: 1,
          }}
        >
          {t("skipApplicant.text3")}{" "}
          <Typography
            component="span"
            sx={{ color: "#1C252E", fontWeight: "600", fontSize: "14px" }}
          >
            {t("skipApplicant.text4")}
          </Typography>{" "}
          {t("skipApplicant.text5")}
        </Typography>
      </Box>
      <Button
        type="button"
        sx={{
          width: {
            xs: "215px",
            sm: "215px",
            md: "215px",
            lg: "215px",
          },
          height: "48px",
          borderRadius: "8px",
          background: "#B1DCFF",
          color: "#1C252E",
          fontSize: "16px",
          fontWeight: "600",
          lineHeight: "24px",
          textTransform: "capitalize",
          border: "1px solid #D0D5DD",
          "&:hover": {
            backgroundColor: "#092552",
            color: "#fff",
          },
          mb: {
            xs: "24px",
            sm: "0px",
            md: "0px",
            lg: "0px",
          },
        }}
        onClick={handleSkipApplicant}
      >
        {t("skipApplicant.button")}
      </Button>
    </>
  );
}

export default SkipApplicant;
